import axios from 'axios';
import { API_BASE_URL } from './apiBase';
import { bearerFromHeaders, shouldEndAdminSession } from '../utils/sessionGuard';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestToken = bearerFromHeaders(error.config?.headers);

    if (shouldEndAdminSession({
      status: error.response?.status,
      message: error.response?.data?.message || '',
      requestToken,
      currentToken: localStorage.getItem('token'),
    })) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      const path = window.location.pathname;
      if (path !== '/login' && path !== '/hackathon') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
